import React, { useState, useEffect } from 'react'
import { Steps } from 'antd-mobile'
import 'static/css/BpmStepType.css'

const { Step } = Steps

/**
 * 底部导航栏
 * @param {步骤} props 
 * @returns 
 */
export function BpmStepType(props) {
  const { stepNum, title } = props

  const [stepContent, setStepContent] = useState([])

  /** 根据stepLength生成stepContent */
  useEffect(() => {
    let stepContent = []
    for (let i = 0; i < title.length; i++) {
      stepContent.push({
        id: i + 1,
        title: title[i] || '步骤' + (i + 1),
        classStyle: i === stepNum - 1 ? true : false,
        content: i + 1,
      })
    }
    setStepContent(stepContent)
  }, [stepNum, title])

  return (
    <Steps
      className='declarationStep'
      current={stepNum - 1}
    >
      {
        stepContent?.map(item =>
          <Step
            key={item.id}
            title={item.title}
            icon={
              <button className={`iconBut ${item.classStyle && 'active'}`}>
                {item.content}
              </button>
            }
          />)
      }
    </Steps>
  )
}